import type { JSX } from 'react'

import { TopNumber9SC } from './TopNumbers.styled'

export const Top9 = (): JSX.Element => (
  <TopNumber9SC
    width='139'
    height='195'
    viewBox='0 0 139 195'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M68.1426 0C91.6712 0 109.318 7.85416 121.082 23.5625C133.027 39.2708 139 62.3819 139 92.8958C139 126.299 132.122 151.667 118.367 169C104.612 186.333 84.3411 195 57.5547 195C48.3242 195 39.8177 193.917 32.0352 191.75C24.4336 189.403 16.651 185.611 8.6875 180.375V151.938H9.77344C17.194 157.354 25.1576 161.507 33.6641 164.396C42.1706 167.285 50.6771 168.729 59.1836 168.729C74.3867 168.729 85.8796 163.854 93.6621 154.104C101.626 144.174 106.241 128.646 107.508 107.521C95.0195 116.549 80.3594 121.062 63.5273 121.062C43.7995 121.062 28.2344 115.826 16.832 105.354C5.61068 94.7014 0 80.3472 0 62.2917C0 49.8333 2.80534 38.9097 8.41601 29.5208C14.0267 20.1319 21.9902 12.9097 32.3066 7.85416C42.623 2.61805 54.5684 0 68.1426 0ZM30.9492 61.2083C30.9492 71.8611 34.207 80.2569 40.7227 86.3958C47.2383 92.3542 56.1068 95.3333 67.3281 95.3333C81.2643 95.3333 94.6575 90.6389 107.508 81.25C106.603 62.1111 102.983 48.1181 96.6484 39.2708C90.3138 30.4236 80.8119 26 68.1426 26C56.9212 26 47.8717 29.25 40.9941 35.75C34.2975 42.0694 30.9492 50.5556 30.9492 61.2083Z'
      fill='url(#paint0_linear_5096_100024)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100024'
        x1='-14.6602'
        y1='3.01302'
        x2='172.547'
        y2='171.307'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber9SC>
)
